<template>
    <v-app>
        <v-app-bar clipped-left clipped-right app color="white">
            <img src="./assets/medici.jpg" height="100%">

            <!--
            <v-spacer></v-spacer>
            <a href="https://rdnest.com" target="_blank" style="height: 70%;">
                <img src="./assets/rdnest.png" height="100%" class="hidden-xs-only">
                <img src="./assets/rdnest.png" height="40%" class="hidden-sm-and-up mt-3">
            </a>
            -->
      
            <v-col v-if="!!getCurrentSubject" class="ml-auto">
                <div class="body-2 font-weight-bold">
                    {{ $t('subject') }}
                </div>
                <div class="subtitle-1 font-weight-light mr-12">
                    {{ getCurrentSubject }} 
                </div>
            </v-col>

            <v-col lg=2 sm=3 class="ml-auto">
                <div class="body-2 font-weight-bold">
                    {{ $t('knowledgeArea') }}
                </div>
                <div class="headline font-weight-light mr-12">
                    {{ getKnowledgeArea }}
                </div>
            </v-col>

            <v-toolbar-items v-if="isAuthenticated">
                <v-btn text to="/" exact>
                    <v-icon left>home</v-icon>
                    {{ $t('home') }}
                </v-btn>

                <v-btn text v-if="!isAuthenticated" :loading="isLoading" :disabled="isLoading" to="/login" exact>
                    <v-icon left>input</v-icon>
                    {{ $t('logIn') }}
                </v-btn>
                <v-btn text v-if="isAuthenticated" :loading="isLoading" :disabled="isLoading" @click="logOut">
                    <v-icon left>power_settings_new</v-icon>
                    {{ $t('logOut') }}
                </v-btn>
            </v-toolbar-items>
        </v-app-bar>

        <v-snackbar v-model="snackBar" :color="getSnackBar.color" top :timeout="5000">
            {{ getSnackBar.text }}
            <v-btn text @click="$store.commit('setSnackBar', {value: false})">{{ $t('close') }}</v-btn>
        </v-snackbar>

        <v-content>
            <router-view :key="$route.fullPath"/>
        </v-content>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    methods: {
        logOut() {
            this.$store.dispatch('logout')
        },
    },

    computed: {
        ...mapGetters([
            'isAuthenticated',
            'isLoading',
            'getSnackBar',
            'getCurrentSubject',
            'getKnowledgeArea',
        ]),
        snackBar: {
            get() { return this.getSnackBar.value },
            set(value) { this.$store.commit('setSnackBar', {value}) }
        },
    },

    created(){
        this.$store.dispatch('getKnowledgeArea')
    },

};
</script>
